<div class="row">
    <div class="col-12" [ngClass]="{'col-md-3': !is_modal}">
        <div class="card">
            <div class="card-header">
                <div class="card-title mb-0">Ledger Entry</div>
            </div>
            <div class="card-body">
                <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
                    <div class="mb-3">
                        <label for="date" class="form-label">Date <em>*</em></label>
                        <input type="date" class="form-control" id="date" name="date" #date="ngModel" [(ngModel)]="data.date" required autocomplete="off">
                        <div *ngIf="f.submitted && date.invalid" class="invalid-feedback">
                            <div *ngIf="date.errors.required">Date is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="type" class="form-label">Type <em>*</em></label>
                        <select class="form-control" id="type" name="type" #type="ngModel" [(ngModel)]="data.type" required>
                            <option value="credit">Credit 出钱</option>
                            <option value="debit">Debit 进钱</option>
                        </select>
                        <div *ngIf="f.submitted && type.invalid" class="invalid-feedback">
                            <div *ngIf="type.errors.required">Type is required</div>
                        </div>
                    </div>
                    <hr/>
                    <div class="mb-3">
                        <label for="title" class="form-label">Title / Descp <em>*</em></label>
                        <input type="title" class="form-control" maxlength="99" id="title" name="title" #title="ngModel" [(ngModel)]="data.title" required autocomplete="off">
                        <div *ngIf="f.submitted && title.invalid" class="invalid-feedback">
                            <div *ngIf="title.errors.required">Title is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="amount" class="form-label">Amount <em>*</em></label>
                        <input type="number" class="form-control" maxlength="12" id="amount" name="amount" #amount="ngModel" [(ngModel)]="data.amount" required autocomplete="off">
                        <div *ngIf="f.submitted && amount.invalid" class="invalid-feedback">
                            <div *ngIf="amount.errors.required">Amount is required</div>
                        </div>
                    </div>
                    <div class="d-flex flex-row justify-content-between">
                        <button type="submit" class="btn btn-primary">Create</button>
                        <button type="button" class="btn btn-danger" (click)="cancel()">Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>